import React from 'react';

import CookieModal from '../cookieConsent/CookieModal';
import Footer from '../footer/Footer';
import LiveChat from '../liveChat/LiveChat';
import BottomNav from '../navigation/BottomNav';
import TopNav from '../navigation/TopNav';
import { footerLinks } from './pageLinks';

const PageLayout = ({ children }: { children: React.ReactNode }) => (
  <>
    <LiveChat />
    <TopNav />
    <main>{children}</main>
    <Footer data={footerLinks} />
    <CookieModal />
    <BottomNav />
  </>
);

export default PageLayout;
